import enhance from './enhancers'
import StartOver from './StartOver'

export default enhance(StartOver)



// WEBPACK FOOTER //
// ./client/modules/user/components/StartOver/index.js